<template>
   <div>
      <div class="modal fade" id="recModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
         <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                     <i class="fas fa-user-friends"></i>
                     Choose a Recruiter
                  </h5>
                  <button type="button" class="close" aria-label="Close" @click.prevent="cancelPressed">
                     <span aria-hidden="true">&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <div class="row">
                     <div class="col-12 text-right">
                        <hier-ddl :hierarchies="hierarchies" :selectedHierarchy="selectedHierarchy"
                           @hier-changed="hierarchyChanged"></hier-ddl>
                     </div>
                  </div>
                  
                  <!-- Nav tabs -->
                  <ul class="nav nav-tabs">
                     <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#recsearch" id="search_tab">SEARCH</a>
                     </li>
                     <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#rechier" id="hier_tab">HIERARCHY</a>
                     </li>
                  </ul>
                  <div class="tab-content" id="tc">
                     <!-- Search TAB -->
                     <div id="recsearch" class="tab-pane fade show active">
                        <c-agent 
                           :criteria="criteria" 
                           @crit-change="criteriaChange" 
                           @search-clicked="searchButton" 
                           :searching="busy"
                        ></c-agent>
                        <div v-if="showResults">
                           <div class="b-card">
                              <div class="card-header bg-transparent">
                                 <i class="fi-creative-users"></i>
                                 <span class="card-label">Agent Downline Search Results</span> 
                              </div>
                              <div class="card-body">
                                 <div class="font-smaller" v-if="searchHasData()">
                                    <data-grid 
                                          :headers="searchHeaders" 
                                          :records="searchResults" 
                                          :rowsPerPage="searchPageSize" 
                                          :currentPage="searchPage" 
                                          :totalRecords="searchTotalRecs" 
                                          :clickHandler="searchGridClickHandler"
                                          :navHandler="searchGridNavHandler"
                                          :noDataMsg="noDataMsg"
                                          @page-size-changed="searchPageChanged">
                                    </data-grid>
                                 </div>
                                 <div class="text-danger" v-if="!searchHasData()">
                                    {{ noDataMsg }}
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <!-- Hierarchy TAB -->
                     <div id="rechier" class="tab-pane fade">
                        <div class="row">
                           <div class="col-12">
                              <div class="b-card">
                                 <div class="card-header bg-transparent">
                                    <div class="reset-link">
                                       <a href="#" @click.prevent="runFetchStart"
                                          v-tooltip:Left="'Refresh the tree starting with the logged in agency'">
                                          <i class="fas fa-sync"></i>
                                          RESET
                                       </a>
                                    </div>
                                    <i class="fi-creative-users"></i>
                                    <span class="card-label">Active Recruiters</span>
                                 </div>
                                 <div class="card-body">
                                    <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="busy"></i>
                                    <div v-else>
                                       <div class="instructions marb-12">Click on a recruiter's name to select them...</div>
                                       <tree v-if="datafound" :treeitem="records" :pageSize="pageSize" :selected="selected"
                                          :enableAppointLink=false @node-click="treeItemClicked"
                                          @more-click="moreItemsClicked"
                                       ></tree>
                                       <div class="none-found not-found-text" v-else>None found. Please Search Again...
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn ml-bk-blue ml-white ml-h-orange" @click.prevent="cancelPressed">
                     <span v-if="!busy">
                        <i class="fi-interface-previous"></i>
                        CANCEL
                     </span>
                     <span v-else><i class="fas fa-spinner fa-spin"></i></span>
                  </button>
               </div>
            </div>
         </div>
      </div>

   </div>
</template>

<script>
import $ from "jquery"
import Tree from '../components/tree.vue'
import AgentCriteria from '../components/AgentC.vue'
import DataGrid from "@/components/datagrid.vue"
import hierDDL from "@/components/hierarchyDDL.vue"

export default {
   name: "FindRecruiter",
   props: {
      visible: Boolean
   },
   components: {
      'tree': Tree,
      'c-agent': AgentCriteria,
      'data-grid': DataGrid,
      'hier-ddl': hierDDL
   },
   data() {
      return {
         busy: false,
         selectedHierarchy: null,
         hierarchies: [],
         criteria: '',
         selected: {},
         records: {},
         showResults: false,
         page: 1,
         pageSize: 40,
         // search results grid
         searchResults: [],
         searchPage: 0,
         searchPageSize: 10,
         searchTotalRecs: 0,
         searchHeaders: [
            {
               name: "agentNumber",
               label: "Agent #",
               sortable: true,
               isdate: false,
               ismoney: false
            },
            {
               name: "lastName",
               label: "Last Name",
               sortable: true,
               isdate: false,
               ismoney: false
            },
            {
               name: "firstName",
               label: "First Name",
               sortable: true,
               isdate: false,
               ismoney: false
            },
            {
               name: "companyName",
               label: "Company Name",
               sortable: true,
               isdate: false,
               ismoney: false
            },
            {
               name: "hierarchyLevel",
               label: "Level",
               sortable: true,
               isdate: false,
               ismoney: false
            },
            {
               name: "__ACTION",
               label: "Select",
               sortable: false,
               isdate: false,
               ismoney: false,
               tt: 'Select Recruiter'
            }
         ],
         noDataMsg: 'No data found. Please Search again...',

      }
   },
   watch: {
      visible(newV, oldV) {
         if (newV == true) {
            this.showDialog()
         } else {
            this.hideDialog()
         }
      }
   },
   computed: {
        datafound() {
            return (this.records != {} && !this.isEmpty(this.records))
        },
        searchTotalPages() {
           return this.searchHasData ? Math.trunc(this.searchTotalRecs / this.searchPageSize) + (this.searchTotalRecs % this.searchPageSize > 0 ? 1 : 0) : 0
        }
    },
   created() {
      this.initialize()
   },
   methods: {
      async initialize() {
         // Load hierarchies
         this.busy = true
         this.hierarchies = this.$store.getters.hierarchies

         if (!this.hierarchies || this.hierarchies.length < 1) {
            await this.$store.dispatch("getHierarchies")
            this.hierarchies = this.$store.getters.hierarchies
         }
         if (this.hierarchies && this.hierarchies.length > 0) {
            this.selectedHierarchy = this.hierarchies[0]
            await this.fetchStart()
         }
         this.busy = false
      },
      showDialog() {
         $('#recModal').modal('show')
      },
      hideDialog() {
         $('#recModal').modal('hide')
      },
      cancelPressed() {
         this.$emit('oncancelled', null)
      },
      // Tree methods ---------------------
      async treeItemClicked(node) {
         let nodeLevel = parseInt(node.hierarchyLevel)
         if (nodeLevel < this.selAgentLevel) {
            this.$swal(
               "Details Unavailable",
               "Details are only available for the current user's downline.",
               "warning"
            );
            return
         }
         let payload = {
            recruiterName: node.lastName==null ? `${node.companyName}` : `${node.lastName}, ${node.firstName}`,
            recruiterAgentNo: node.agentNumber,
            recruiterCompanyNo: node.companyNumber,
            recruiterBlockNo: node.blockNumber,
            recruiterLevel: node.hierarchyLevel
         }
         this.$emit('onselected', payload)
      },
      async moreItemsClicked(node) {
         this.busy = true
         let payload = {
               AgentNumber : node.agentNumber,
               CompanyNumber : node.companyNumber, 
               BlockNumber : node.blockNumber,
               PageSize : this.pageSize,
               PageNumber : node.childPage + 1,
               ParentLevels : 0,
               ChildLevels : 1,
               NameFilter: this.nameFilter
            }

            await this.$agent.getTreeChildren(payload)
            .then((r) => {
               node.childPage += 1
               if (r && r.length > 0) {
                  if (node.children == null) {
                     this.$set(node, 'children', [])
                  }
                  r.forEach((itm,indx) => {
                     node.children.push(itm)
                  })
               }
               this.nameFilter = ''
               this.busy = false
            })
            .catch((err) => {
               this.busy = false
            })
      },
      async runFetchStart() {
         this.busy = true
         await this.fetchStart()
         this.busy = false
      },
      async fetchStart(item) {
         // Get the starting data for the hierarchy
         if (this.selectedHierarchy != null) {
            let s = this.selectedHierarchy

            let parentLvl = 1
            let agentNo = s.agentNo
            let blockNo = s.blockNo
            let companyNo = s.companyNo

            if (item) {
               this.activateTreeTab()
               agentNo = item.agentNumber
               blockNo = parseInt(item.block)
               if (item.company == '') {
                  companyNo = 0
               } else {
                  companyNo = parseInt(item.company)
               }
               parentLvl = item.treeLevel
            }
            let payload = {
               AgentNumber: agentNo,
               CompanyNumber: companyNo,
               BlockNumber: blockNo,
               PageSize: this.pageSize,
               PageNumber: this.page,
               ParentLevels: parentLvl,
               ChildLevels: 1
            }

            await this.$agent.getTree(payload)
               .then((r) => {
                  if (r && r.length > 0) {
                     this.selected = r[0]
                     var agentNumFound = false
                     this.setSelected(r, agentNo, agentNumFound)
                     this.$set(this, 'records', r[0])
                  } else {
                     this.noDataMsg = "None found. Please search again or change hierarchy..."
                     this.records = {}
                     this.searchTotalRecs = 0
                     this.searchResults = null
                  }

                  this.nameFilter = ''
               })
               .catch((err) => {
                  // log err
               })
         }
      },
      setSelected(data, agentNo, agentNumFound) {
         data.forEach((item, index) => {
            if (item.agentNumber == agentNo) {
               //Once we found the Agent Number, we don't need to hide the Level Number anymore.  Anyone below him/her can show the Level Number.
               agentNumFound = true
               this.selected = item
               this.selAgentLevel = parseInt(item.hierarchyLevel)
            } else {
               if (item.children && item.children.length > 0) {
                  //Anyone above the selected level should hide the Level Number.
                  if (!agentNumFound)
                     item.showLevel = false
                  this.setSelected(item.children, agentNo, agentNumFound)
               }
            }
         })
      },
      // GRID METHODS --------------------
      isEmpty(obj) {
         return Object.keys(obj).length === 0
      },  
      async criteriaChange( newCrit ) {
         this.showResults = false
         this.criteria = newCrit
      },
      async searchButton() {
         this.searchPage = 0
         this.search()
      },
      async searchGridClickHandler( node ) {
         let payload = {
            recruiterName: node.lastName==null ? `${node.companyName}` : `${node.lastName}, ${node.firstName}`,
            recruiterAgentNo: node.agentNumber,
            recruiterCompanyNo: node.company,
            recruiterBlockNo: node.block,
            recruiterLevel: node.hierarchyLevel
         }
         this.$emit('onselected', payload)
      },
      async searchGridNavHandler() {

      },
      async searchPageChanged() {

      },
      async hierarchyChanged(itm) {
         this.showResults = false
         this.selectedHierarchy = itm
         this.busy = true
         await this.fetchStart()
         this.busy = false
      },
      async search() {
         if (this.selectedHierarchy == null || this.selectedHierarchy == {}) return
         if (!this.criteria || (this.criteria.lastname.trim() + 
            this.criteria.firstname.trim() + 
            this.criteria.agentnumber.trim() + 
            this.criteria.companyname.trim()).length < 1) {
            this.$swal(
               "Search for What?",
               "Please enter some search criteria before searching.",
               "error"
            );
            return
         }
         let h = this.selectedHierarchy
         this.busy = true;
         this.showResults = false;

         let payload = {
            parentAgentNumber: h.agentNo,
            parentCompanyNumber: h.companyNo,
            parentBlockNumber: h.blockNo,
            lastName: this.criteria.lastname,
            firstName: this.criteria.firstname,
            agentNumber: this.criteria.agentnumber,
            companyName: this.criteria.companyname,
            pageSize: this.searchPageSize,
            page: this.searchPage + 1
         }

         await this.$agent.searchDownline(payload)
            .then((r) => {
               this.searchTotalRecs = r.totalRecords
               this.searchResults = r.results
               this.busy = false;     
               this.showResults = true;
            })
            .catch((err) => {
               this.busy = false; 
               this.showResults = false;
               this.$swal(
                  "Oops!",
                  "An error occured fetching your search results. Please try again later or contact support if the problem persists.",
                  "error"
               );
            })
      },
      searchHasData() {
         if (this.searchResults != null) {
               return this.searchResults.length > 0
         }
         return false
      },
   }
}
</script>

<style lang="scss">
.reset-link, .reset-link.visited {
   float: right;
   font-size: small;
   text-decoration: none;
}
.reset-link:hover {
   color: #000;
   text-decoration: none;
}
.extra-text {
   color: #999;
   font-size: small;
}
#tc {
   margin-bottom: 0px;
}
</style>